<template>
	<div>
		<div class="headView">
			<div class="headView_top">
				<p class="applyTitle">项目名称：{{basicParams.project_name}}</p>
				<div class="headView_top_btn" v-if="allSubmit">
					<!-- showScore  -->
					<button type="button" @click="upShow('tips')">确认提交</button>
					<div class="btnTips">
						<img src="../../assets/img/login/注释.png" style="width: 18px;height: 18px;">
						<p>一旦提交，不可修改，请谨慎操作</p>
					</div>
				</div>
			</div>
			<div class="headClass">
				<p>项目类型：{{basicParams.project_type_name}}</p>
				<p>申请时间：{{basicParams.apply_start}}-{{basicParams.apply_end}}</p>
				<p>审核时间：{{basicParams.app_start}}-{{basicParams.app_end}}</p>
			</div>
		</div>
		<!-- 申报审核通用封装组件 -->
		<div class="content_view">
			<div class="contentLeft">
				<p v-for="(item,index) in navList" v-if="item" :key="index" @click="changeTab(index)"
					:class="navIndex === index?'tabActive':''">
					{{item}}
				</p>
			</div>
			<div class="contentRight">
				<div v-show="navIndex === 0">
					<p class="view_head">申报须知</p>
					<!-- pdf -->
					<div style="height: 650px;overflow-y: scroll">
						<pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
					</div>
					<div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
						<el-button :type="primary" @click="doReady" :disabled="disabled">{{btnContent}}</el-button>
					</div>

				</div>

				<div v-show="navIndex === 1">
					<p class="view_head">评选办法</p>
					<!-- pdf -->
					<div style="height: 650px;overflow-y: scroll">
						<pdfVue v-if="selection_pdf_url" :pdf_url="selection_pdf_url"></pdfVue>
					</div>
					<div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
						<el-button :type="primary" @click="doReady2" :disabled="disabled">{{btnContent}}</el-button>
					</div>
				</div>

				<div v-show="navIndex === 2">
					<p class="view_head">
						基本信息
					</p>

					
				</div>

				<div v-show="navIndex == 3">
					<p class="view_head" v-show="projectType !== '0'">获奖信息</p>
					
					
				</div>
				<div class="uploadContent" v-show="navIndex === 4">
					<div v-show="projectType !== '0'">
						<p class="view_head">资料上传</p>
						<div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
							<div class="uploadList_head">
								<p>{{item}}</p>
								<div class="head_list">
									<img v-if="index === 0" src="../../assets/img/main/download.png"
										style="width: 20px;height: 20px;">
									<p v-if="index === 0" @click="downLoadFile" style="margin-right: 20px;">点击生成</p>
									<p v-if="index === 1 && projectType==2" @click="upShow('muban')"
										style="margin-right: 20px;">
										<img src="../../assets/img/main/download.png"
											style="width: 20px;height: 20px;">模板下载
									</p>
									<p v-if="index === 2 && projectType==3" @click="upShow('muban')"
										style="margin-right: 20px;">
										<img src="../../assets/img/main/download.png"
											style="width: 20px;height: 20px;">模板下载
									</p>
									<img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
									<p @click="upShow('upload',index)">点击上传</p>
								</div>
							</div>
							<div class="uploadList_mid">
								<p>{{uploadData.tips[index]}}</p>
							</div>
							<div class="uploadList_bot">
								<div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
									@click="showPriv(item)">
									<p>{{item.name?item.name:item.data_name}}</p>
									<img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-show="navIndex === 5">
					<p class="view_head">资料上传</p>
					<div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
						<div class="uploadList_head">
							<p>{{item}}</p>
							<div class="head_list">
								<img v-if="index === 1" src="../../assets/img/main/download.png"
									style="width: 20px;height: 20px;">
								<p v-if="index === 1" @click="downLoadFile" style="margin-right: 20px;">点击生成</p>
								<img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
								<p @click="upShow('upload',index)">点击上传</p>
							</div>
						</div>
						<div class="uploadList_mid">
							<p>{{uploadData.tips[index]}}</p>
						</div>
						<div class="uploadList_bot">
							<div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
								@click="showPriv(item)">
								<p>{{item.name?item.name:item.data_name}}</p>
								<img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="uploadBtn" v-show="navIndex == 2">
			<el-button type="primary" @click="basicInfo">保存</el-button>
		</div>

		<div class="uploadBtn" v-show="navIndex == 3">
			<el-button v-if="projectType !=='0'" type="primary" @click="getWinninginfo">保存</el-button>
			<el-button v-if="projectType ==='0'" type="primary" @click="personInfo">保存</el-button>
		</div>
		<div class="uploadBtn" v-show="navIndex == 4">
			<div v-show="projectType ==='0'">
				<el-button type="primary" @click="getWinninginfo">保存</el-button>
			</div>
			<div v-show="projectType !=='0'" style="display: flex;flex-flow: column;">
				<div class="content_btn">
					<p>资料上传后请点击保存</p>
				</div>
				<el-button type="primary" @click="setUploadFile">保存</el-button>
			</div>

		</div>

		<div class="uploadBtn" v-show="navIndex == 5" style="display: flex;flex-flow: column;">
			<div class="content_btn">
				<p>资料上传后请点击保存</p>
			</div>
			<el-button type="primary" @click="setUploadFile">保存</el-button>
		</div>

		<!-- 弹窗 -->
		<addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
	</div>
</template>

<script>
	// getUploadFile上传文件附件
	import {
		getProjectDetail,
		getWinningInfo,
		sureSubmit,
		getUploadFile,
		getDataItem,
		setPersonInfo
	} from '../../api/moudles/manager.js'
	import {
		API_DOMAIN
	} from '../../api/api.js'
	import {
		vaildte
	} from '../../utils/validate.js'
	import pdfVue from './components/pdfVue.vue'
	import labelText from '../../components/table/labelText.vue'
	import labelInput from '../../components/table/labelInput.vue'
	import normalPicker from '../../components/table/normalPicker.vue'
	import normalSelect from '../../components/table/normalSelect.vue'
	import addDialog from './components/addDialog.vue'

	export default {
		data() {
			return {
				makeShow: 0,
				basicMsg: {},
				awardMsg: [],
				// 质量小组基本信息
				basicInfo_6: {},
				check: false,
				disabled: false,
				// 参建单位
				textarea: '',
				textarea2: '',
				oldAddList: [],
				addList: [
					// 	{
					// 	type: '',
					// 	name: '',
					// },
				],
				// 参建方式
				installList: [
					[{
						name: '建设单位',
						code: '建设单位'
					}, {
						name: '设计单位',
						code: '设计单位'
					}, {
						name: '监理单位',
						code: '监理单位'
					}, {
						name: '其他施工单位',
						code: '其他施工单位'
					}]
				],
				projectType: '',
				basicParams: {},
				navIndex: 0,
				newnavIndex: 0,
				primary: 'primary',
				spanWidth: '180px',
				navList: [
					"申报须知",
					"评选办法",
					"基本信息",
					"获奖信息",
					"资料上传"
				],
				// 基本信息的
				req_num_code: '',
				project_code: '',
				// 基本信息表单
				levelOne: {},
				// 优质安装工程
				levelThree: {
					company_name: '',
					contact_name: '',
					dep: '',
					cellphone: '',
					phone: '',
					project_name: '',
					declared_project: '',
					construc_enp: '',
					use_enp: '',
					design_enp: '',
					supervise_enp: '',
				},
				// 基本信息表单
				formName: {
					real_name: '姓名',
					id_card: '身份证',
					birth_date: '出生年月',
					// project_code: '',
					education: '学历',
					join_work_time: '参加工作时间',
					title: '职称',
					major: '建造师专业',
					level: '建造师等级',
					req_num: '注册编号',
					cellphone: '本人联系电话',
					head_dep: '单位主管部门',
					enp_contact: '单位联系人',
					enp_contact_phone: '联系电话',
					// continue_year: '最近一次教育年度',
					// 优秀建造师
					present_post: '职务',
					project_name: '项目名称',
					company_name: '单位名称',
					contacts: '联系人',
					contacts_phone: '联系人电话',
					achievement_name: '成果标题',
					headcount: '编制人数',
					engineering: '项目部名称',
					author: '编制人姓名',
					// 优质安装工程
					// company_name:'单位名称',
					contact_name: '联系人',
					dep: '所在部门',
					// cellphone:'手机号',
					// phone: '固定电话',
					// project_name:'工程名称',
					declared_project: '申报工程内容',
					construc_enp: '建设单位',
					use_enp: '使用单位',
					design_enp: '设计单位',
					supervise_enp: '监理单位',
					// participating_units:'',
					// 质量小组
					declaration_unit: '申报单位',
					unit_address: '单位地址',
					group_name: '小组名称',
					topic_name: '课题名称',
					course_type: '课程类型',
					contacts_name: '单位联系人',
					contacts_cellphone: '联系人手机',
					publisher: '发布人姓名',
					publisher_phone: '发布人手机号',
					post: '获奖工程所从事职务',
					tellphone: '本人联系电话',
					introduction: '小组简介',
					// 先进企业
					// company_name:'',
					// contacts:'',
					// contacts_phone:'',
					output_value: '总产值',
					contract_amount: '合同额',
					liability_ratio: '资产负债率',
					profit_rate: '产值利润率',
					growth_rate: '净资产增长率',
					declarant_name: '申报人姓名',
					declarant_post: '申报人职位',
					declarant_phone: '申报人电话',
					achievement_name: '成果名称',
					achievement_group: '成果分组',
					contacts_name: '联系人姓名',
					contacts_phone: '联系人电话',
					contacts_address: '联系地址',
					declarant_units: '申报单位',
					leading_member: '团队成员',
				},
				// 获奖信息
				project_app_num: '',
				award_msg: ['质量获奖情况', '安全文明情况'],
				levelTwo: {
					awardJson: [{}, {}, ]
				},
				// 申报须知
				require_pdf_url: '',
				// 评选办法
				selection_pdf_url: '',
				btnContent: '我已阅读',
				totalTime: 15,
				canClick: true, //添加canClick
				// 模板下载列表
				modelList: [],
				// 上传文件列表
				clickIndex: 0,
				uploadList: [],
				// 最终提交
				allSubmit: false,
				// 资料上传内容
				uploadData: '',
				listArray: []
			}
		},
		components: {
			labelInput,
			labelText,
			addDialog,
			pdfVue,
			normalPicker,
			normalSelect,
		},
		created() {
			this.countDown()
			if (!this.$route.params.projectCode) {
				this.$router.go(-1)
				return
			}
			// 获取pdf
			this.getProjectdetail(this.$route.params.projectCode)
			// 模板下载列表
			this.modelList = JSON.parse(this.$route.params.distribution_materials)
			// 获取项目类型字段
			const projectType = this.$route.params.type
			this.projectType = projectType

			// 绑定project_code
			this.levelOne.project_code = this.$route.params.projectCode
			this.project_code = this.$route.params.projectCode
			getDataItem({
				data: {
					type: projectType
				},
				success: res => {
					// console.log(res)
					this.uploadData = res.data
				}
			})
		},
		methods: {
			async personInfo() {
				await setPersonInfo({
					data: {
						content: this.textarea,
						personal_resume2: this.textarea2,
						project_app_num: this.project_app_num
					},
					success: res => {
						console.log('res', res)
						if (res.code === 200) {
							this.$message({
								type: 'success',
								message: '保存成功!'
							});
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			countDown() {
				if (!this.canClick) return //改动的是这两行代码
				this.canClick = false
				this.btnContent = '我已阅读' + '(' + this.totalTime + 's)'
				this.disabled = true
				let clock = window.setInterval(() => {
					this.totalTime--
					this.btnContent = '我已阅读' + '(' + this.totalTime + 's)'
					if (this.totalTime < 0) {
						window.clearInterval(clock)
						this.btnContent = '我已阅读'
						this.disabled = false
						this.totalTime = 15
						this.canClick = true //这里重新开启
					}
				}, 1000)
			},

			doReady() {
				this.makeShow++
				this.navIndex++
				this.countDown()
			},
			doReady2() {
				this.makeShow++
				this.navIndex++
			},
			// 下载pdf模板
			downLoadFile() {
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				const url =
					`${API_DOMAIN}/proapi/down/download-basic-msg?type=${this.projectType}&project_app_num=${this.project_app_num}&project_name=${this.basicParams.project_name}`
				window.open(url)
			},
			moreSelect(e) {
				this.listArray = e
			},
			// 保存的图片删除
			deleteUpload(key, index) {
				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.uploadList[index].splice(key, 1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 新增参建单位输入
			typeThreeInput(e, type, index) {
				if (type == '1') {
					this.addList[index].type = e
				} else {
					this.addList[index].name = e
				}
			},
			// 删除行
			deleteList(index, type) {
				const number = this.addList.length + this.oldAddList.length
				if (number === 1) {
					this.$message.error(`至少填写一条参建信息`)
					return
				}
				if (type === '1') {
					// 例旧信息
					this.oldAddList.splice(index, 1)
				} else {
					this.addList.splice(index, 1)
				}

			},
			// 新增参建单位
			addInstall() {
				this.addList.push({})
			},
			// 预览
			showPriv(e) {
				window.open(e.url);
			},
			// 上传文件附件保存
			async setUploadFile() {
				let newArray = this.uploadList.filter(function(s) {
					return s && s.length
				});
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				if (!newArray.length) {
					this.$message.error('请先上传文件')
					return
				}
				if (newArray.length < 2) {
					this.$message.error('至少上传两条')
					return
				}
				let dataJson = []
				this.uploadList.forEach((items, key) => {
					items.forEach((item, index) => {
						let data = {}
						data['data_name'] = item.name ? item.name : item.data_name
						data['type'] = key + 1
						data['stored_path'] = item.url ? item.url : item.stored_path
						dataJson.push(data)
					})
				})
				const params = {
					dataJson: dataJson,
					project_app_num: this.project_app_num
				}
				await getUploadFile({
					data: params,
					success: res => {
						// console.log(res)
						if (res.code === 200) {
							this.$message({
								message: res.msg + ',现在可以确认提交',
								type: 'success'
							});
							this.allSubmit = true
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			//接受点击上传回穿
			submitSuccess(e) {
				if (this.uploadList[this.clickIndex]) {
					let newList = [...this.uploadList[this.clickIndex], ...e]
					this.$set(this.uploadList, this.clickIndex, newList)
					return
				}
				this.$set(this.uploadList, this.clickIndex, e)
			},
			// 切换tab栏/
			changeTab(index) {
				if (this.makeShow > 1) {
					this.navIndex = index
				} else {
					this.$message.error('还没完成阅读')
				}
			},
			// 获取必填警示
			requireSubmit(params, nameList) {
				//如果数据是对象形式
				let upString = []
				Object.keys(params).forEach((item, index) => {
					if (params[item] == '' || params[item] == undefined || params[item] == null) {
						if (nameList[item]) {
							upString.push(item)
						}
					}
				})
				if (!upString.length) {
					return false
				} else {
					this.$message.error(`${nameList[upString[0]]}未填写`)
					return true
				}
				// 如果数据是数组形式
			},

			// 获取项目明细
			async getProjectdetail(project_code) {
				await getProjectDetail({
					data: {
						project_code
					},
					success: (res) => {
						// console.log('获取项目明细', res.data)
						// 基本信息
						if (res.data.basicMsg) {

							this.makeShow = 2;

							this.basicMsg = res.data.basicMsg

							this.textarea = this.basicMsg.personal_resume
							this.textarea2 = this.basicMsg.personal_resume2

							if (this.basicMsg.participating_units) {
								this.oldAddList = JSON.parse(this.basicMsg.participating_units)
							}
							this.project_app_num = res.data.basicMsg.project_application_id

						}
						// 获奖信息
						if (res.data.award_list) {
							this.awardMsg = res.data.award_list
							// console.log('获取项目明细', res.data.award_list)
						}
						// 文件上传
						if (res.data.data_list) {
							const uploadList = res.data.data_list
							let newUploadList = []
							uploadList.forEach((item, index) => {
								newUploadList[Number(item.type) - 1] = []
							})
							uploadList.forEach((item, index) => {
								newUploadList[Number(item.type) - 1].push(item)
							})
							this.uploadList = newUploadList
						}

						this.basicParams = res.data
						// 申报须知PDF
						this.require_pdf_url = res.data.require_pdf_url
						// 评选办法PDF
						this.selection_pdf_url = res.data.selection_pdf_url
					}
				})
			},
			// 提交获奖信息
			async getWinninginfo() {
				const params = {
					awardJson: [...this.levelTwo.awardJson]
				}
				const newParams = params.awardJson
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				await getWinningInfo({
					data: params,
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							// 自定义判断获奖信息 题没提交成功
						} else {
							this.$message.error(res.msg)
						}
					},
					fail: (err) => {
						console.log(err)
					}
				})
			},
			// 模板下载弹窗
			upShow(type, index) {
				this.clickIndex = index
				if (type === 'muban') {
					const params = {
						type,
						download: this.modelList
					}
					this.$refs['download'].showAdd(params)
				} else if (type === 'tips') {
					const params = {
						type,
						project_app_num: this.project_app_num
					}
					this.$refs['download'].showAdd(params)
				} else {

					sessionStorage.setItem('dataUpload', index);

					if (this.projectType === '2' && index === 1) {
						const params = {
							type,
							project: true,
						}
						this.$refs['download'].showAdd(params)
					} else {
						const params = {
							type,
							project_app_num: this.project_app_num
						}
						this.$refs['download'].showAdd(params)
					}
				}
			},

			// 基本信息申报
			async basicInfo() {
				const params = {
					...this.levelOne
				}
				if (this.project_app_num) {
					params.project_app_num = this.project_app_num
				}
				// 验证各个工程的表单
				if (this.requireSubmit(params, this.formName)) {
					return
				}
			},
			// 输入基本信息
			labelInput(e, name) {
				this.levelOne[name] = e
			},
			// 新增获奖信息
			labelInput3(e, name, id) {
				if (e) {
					this.levelTwo.awardJson[id][name] = e
				} else {
					delete this.levelTwo.awardJson[id][name]
				}

			}
		}
	}
</script>

<style scoped>
	/* 每个上传文件的样式 */
	.inner_upload {
		position: relative;
		min-height: 40px;
		margin: 0 10px;
		/* width: 100px; */
		/* overflow: scroll; */
	}

	.inner_upload p {
		color: #1890FF;
	}

	.inner_upload img {
		border-radius: 50%;
		position: absolute;
		right: 0;
		top: 0;
		width: 15px;
		height: 15px;
		cursor: pointer;
	}


	.headView_top_btn {
		position: relative;
		margin-right: 125px;
	}

	.btnTips {
		margin-top: 10px;
		display: flex;
		position: absolute;
		width: 350px;
		align-items: center;
	}

	.btnTips p {
		margin-left: 10px;
		font-size: 13px;
		color: #FE2c54;
	}

	/* 上传样式 */
	.uploadBtn {
		margin-top: 60px;
		margin-bottom: 60px;
		display: flex;
		margin-left: 41.5%;
	}

	.uploadBtn button {
		width: 140px;
	}

	.uploadHead {
		display: flex;
		position: absolute;
		align-items: center;
		left: 255px;
	}

	.uploadHead p {
		margin-left: 10px;
		color: #1890FF;
		cursor: pointer;
	}

	.uploadList {
		border: 1px solid #f0f0f0;
		width: 90%;
		margin-top: 30px;
		margin-left: 5%;
	}


	.uploadList_head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 40px;
		padding: 0 40px 0 10px;
		line-height: 40px;
		font-size: 14px;
		flex-wrap: wrap;
		border-bottom: 1px solid #f0f0f0;
	}

	.uploadList_head p {
		text-align: left;
	}

	.head_list {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.head_list p {
		margin-left: 10px;
	}

	.head_list p:hover {
		color: #1890FF;
		text-decoration: underline;
	}

	.uploadList_mid {
		width: 90%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_mid p {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 24px;
		text-align: left;
		text-indent: 2em;
		padding: 10px;
	}

	.uploadList_bot {
		width: 70%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_bot p {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #1890FF;
		text-decoration: underline;
		margin: 0 20px;
		cursor: pointer;
	}

	/* 上传样式 */
	.uploadContent {
		padding-bottom: 60px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.midflex {
		display: flex;
		width: 90%;
		height: 50px;
		margin-left: 5%;
		align-items: center;
		justify-content: center;
		border-top: 1px solid #eee;
	}

	.newAddBtn {
		width: 100%;
		display: flex;
		height: 70px;
		align-items: center;
		justify-content: center;
	}

	.headView {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}

	.headView_top {
		width: 1350px;
		display: flex;
		justify-content: space-between;
	}

	.headView_top button {
		width: 100px;
		height: 35px;
		background-color: #1890FF;
		color: white;
		line-height: 35px;
		cursor: pointer;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.headClass {
		display: flex;
		margin-top: 10px;
	}

	.headClass p {
		margin-right: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/* 申报 */
	.content_view {
		margin-top: 20px;
		max-width: 1350px;
		min-height: 350px;
		/* min-height: 750px; */
		display: flex;
		border: 1px solid #f0f0f0;
	}

	.contentLeft {
		width: 200px;
	}

	.contentLeft p {
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
		background-color: #fafafa;
		cursor: pointer;
	}

	.contentRight {
		width: 100%;
	}

	.tabActive {
		background: #e6f7ff !important;
		color: #6ea7ff !important;
		border-right: 2px solid #0077ff;
	}

	.content_btn {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
		margin-bottom: 30px;
	}

	.content_btn p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FE2C54;
	}

	.content_btn button {
		width: 150px;
		margin-top: 40px;
		margin-left: 440px;
	}

	.specialView {
		width: 720px;
		display: flex;
		align-items: center;
	}

	.specialView input {
		margin-left: 20px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		letter-spacing: 1px;
		border-bottom: 1px solid #DBDBDB;
	}

	.specialView input::placeholder {
		color: #B5B5B5;
	}

	.dash_bottom {
		margin-top: 30px;
		margin-bottom: 20px;
		border-bottom: 1px solid #DBDBDB;
		margin-left: 120px;
		height: 1px;
		width: 81%;
	}
</style>
